import ContainerCustom from "../../../Components/ContainerCustom";

export default function ChallengeInfoContainer({ data }) {
  return (
    <ContainerCustom
      header="اطلاعات چالش"
      headSVG="info"
      search={false}
      filter={false}
      sort={false}
      colorfulFilter={false}
      divider={false}
      className="flex-none"
    >
      <section className="flex justify-between gap-20 w-full overflow-x-auto text-nowrap">
        <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-zi-border-dark/50">
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              نوع چالش
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {data?.challenge_type
                ? data.challenge_type === "real"
                  ? "واقعی"
                  : "تمرینی"
                : ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              قیمت چالش
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              ${data?.cost || ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark text-nowrap">
              سرمایه اولیه
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              $
              {Number(
                Number(data?.initial_balance).toFixed(2)
              ).toLocaleString() || ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">اهرم</p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {data?.leverage || ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              حداقل روز معاملاتی برای برداشت
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {data?.first_payout_delay_days || ""}
            </p>
          </div>
          {/* <div className="flex justify-between items-center py-3 gap-10">
            <p
              
              className="text-zi-text-light dark:text-zi-text-dark"
            >
              حداکثر ثانیه اسکلپ
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              30
            </p>
          </div> */}
          {/* <div className="flex justify-between items-center py-3 gap-10">
            <p
              
              className="text-zi-text-light dark:text-zi-text-dark"
            >
              حداکثر تعداد معامله و سفارش باز
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              5
            </p>
          </div> */}
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              روش محاسبه درادان کل
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              ثابت
            </p>
          </div>
        </article>

        <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-zi-border-dark/50">
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              دسته چالش
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {data?.category || ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              درصد تخفیف
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {data?.discount_percent || 0}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              پلتفرم معامله
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              کوژیتو
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              درصد تقسیم سود
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {Number(data?.profit_split_ratio) * 100 || ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              حداقل روز برای برداشت پس از اولین معامله
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {data?.first_payout_delay_days_after_trade === 0
                ? "0"
                : data?.first_payout_delay_days_after_trade || ""}
            </p>
          </div>
          {/* <div className="flex justify-between items-center py-3 gap-10">
          <p
            
            className="text-zi-text-light dark:text-zi-text-dark"
          >
            حداکثر درصد مجاز سود اسکلپ
          </p>
          <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
            10
          </p>
        </div> */}
          {/* <div className="flex justify-between items-center py-3 gap-10">
            <p
              
              className="text-zi-text-light dark:text-zi-text-dark"
            >
              نگهداری معامله و سفارش طی روز
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              مجاز
            </p>
          </div> */}
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              روش محاسبه درادان روزانه
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              روزانه
            </p>
          </div>
        </article>

        <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-zi-border-dark/50">
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              نام چالش
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {data?.name || ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              قیمت پس از تخفیف
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              $
              {data?.discount_cost != 0
                ? data?.discount_cost
                : data?.cost || ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              نوع بازار
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              ارز دیجیتال
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              درصد بازگشت هزینه اولیه
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              {Number(data?.refundable_fee) * 100 || ""}
            </p>
          </div>
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              حداکثر روز غیرفعال بودن حساب
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              30
            </p>
          </div>
          {/* <div className="flex justify-between items-center py-3 gap-10">
            <p
              
              className="text-zi-text-light dark:text-zi-text-dark"
            >
              حداکثر درصد مجاز سود هر معامله از کل
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              20
            </p>
          </div> */}
          {/* <div className="flex justify-between items-center py-3 gap-10">
            <p
              
              className="text-zi-text-light dark:text-zi-text-dark"
            >
              نگهداری معامله و سفارش طی هفته
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              مجاز
            </p>
          </div> */}
          <div className="flex justify-between items-center py-3 gap-10">
            <p className="text-zi-text-light dark:text-zi-text-dark">
              روش محاسبه درادان معامله
            </p>
            <p className="text-zi-text-light dark:text-zi-text-dark font-medium [direction:ltr]">
              روزانه
            </p>
          </div>
        </article>
      </section>
    </ContainerCustom>
  );
}
